import { AdminTitle } from "../../../../store/reducers/site"
// lib
import { useState, useRef ,useEffect} from 'react';
import { useFormik, FieldArray, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom'
import WYSIWYG from "../../../../utils/form/wysiwyg";
import * as React from 'react';
import { errorHelper, Loader } from '../../../../utils/tools'
import { validation, formValues } from './onlineItemvalidationSchema'

// redux
import { useDispatch, useSelector } from 'react-redux';
import { addShop ,getAllategory} from "../../../../store/actions/shopAction";
import { getShopsByMcatID ,getItemMcatIDandSubCat,updateItem,getItembyIdOfcView,getAllItems} from "../../../../store/actions/ItemAction";

// MUI
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button' 
import Divider from '@mui/material/Divider' 
//import Chip from '@mui/material/Chip'
//import Paper from '@mui/material/Paper'
//import InputBase from '@mui/material/InputBase'
//import IconButton from '@mui/material/IconButton'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
 
import InputLabel from '@mui/material/InputLabel';
//import AddIcon from '@mui/icons-material/Add';
//import { visuallyHidden } from '@mui/utils';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs, { Dayjs } from 'dayjs';



import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const EditOnlineItem = () => { 
    let { id } = useParams();
    const [editorBlur,setEditorBlur] = useState(false);
    const [editorContent,setEditorContent] = useState(null);
    // redux
    const shop = useSelector(state=>state.shopReducer);
    const users = useSelector(state=>state.users)
    const dispatch = useDispatch();

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubcategory, setSelectedSubcategory] = useState(null);
    const [selectedCategoryMain, setSelectedCategoryMain] = useState(null);
    
    const [selectShops, setselectShops] = useState(null);
    const [mainItem, setMainItem] = useState(null);
    
    const [loading,setLoading] = useState(true);
    const [formData,setFormData] = useState(formValues)

    const [allItem, setAllItem ]= useState(null);
    const [selectedItemUnit, setSelectedItemUnit] = useState(null);
    const [validFrom, setvalidFrom] = React.useState(dayjs(new Date()));
    const [validTo, setvalidTo] = React.useState(dayjs(new Date()));

    
    let mainCat=0;
    let subCat=0;

    
    let navigate = useNavigate();


    const handleEditorState = (state) => {
        formik.setFieldValue('content',state,true)
    }

    const handleEditorBlur = (blur) => {
        setEditorBlur(true)
    }
    function setStringtime (valus){
        let formattedDate = valus.format('YYYY-MM-DDTHH:mm:sss');
            return formattedDate;
      }
   
    


   

    const formik = useFormik({
        enableReinitialize:true,
        initialValues: formData,
        validationSchema:validation,
        onSubmit:(values)=>{

            values.validFrom=setStringtime(validFrom);
           values.validTo=setStringtime(validTo);
         
   
           console.log("66666666666666");
           console.log(values);
           console.log("22222");
           console.log(formValues);
          console.log("2222");

            dispatch(updateItem(values))
            .unwrap()
            .then((response)=>{
       
                if(response!=null)
                {
                    if(response.message==='success')
                    {
                        console.log("22222");
                        console.log(response);
                       console.log("2222");
                     //navigate(`/dashboard/shops/contn/${id}`)
                     //navigate(`/dashboard/shops/contn/${id}`, { replace: true }); 

                     const id=response.id

                     
                     //navigate(`/dashboard/shops/contn/${id}`)
                     navigate(`/dashboard/items/imageupload/${id}_0`, { replace: true }); 
                    }
                }


                
            })
        }
    })

   


  
   
    const handleChange = (id) => {
        id.preventDefault();
       
        setSelectedSubcategory(shop.mCategories)

  
        
        console.log(selectedSubcategory);

       
        formData.mcatId=id.target.value;
        formData.subcatId="";
        formData.shopId="";
        formData.itemID="";
        
        setFormData(formData);
        setSelectedItemUnit(null)
        
        
        const value123 =id.target.value;
       
        
        const filtered = selectedSubcategory.filter(user => user.mcatId===value123);
             

               //setSelectedCategory(id.target.value)    
               setSelectedCategory(filtered[0])    
               setselectShops(null);
               setMainItem(null);
             
               
    }

    const handleChangeSubCat = (id) => {
        id.preventDefault();
         console.log("4444444");
         console.log(id);
         console.log("22222");
         console.log(formValues);
        console.log("23232323");
        formData.subcatId=id.target.value;
        setSelectedItemUnit(null)
        
        setFormData(formData);
        setselectShops(null);
        setMainItem(null);
        console.log(formData);
        console.log("23232323");

       dispatch(getItemMcatIDandSubCat(formData.mcatId+"_"+formData.subcatId))
        .unwrap()
        .then((response)=>{
   
            if(response!=null)
            {
                if(response.message==='success')
                {
                    setMainItem(response.itemsList);
                    setAllItem(response.itemsList)
                    setLoading(false);

                 //navigate(`/dashboard/shops/contn/${id}`)
                 //navigate(`/dashboard/shops/contn/${id}`, { replace: true }); 
                }
            }


            
        })


    }


    const handleItemSelection= (id) => {
        id.preventDefault();
         console.log("4444444");
         console.log(id);
         console.log("22222");
         console.log(formValues);
        console.log("2222");
       formData.itemID=id.target.value;
        
        setFormData(formData);

        const value123 =id.target.value;
        const filtered = allItem.filter(item => item.itemID===value123);
             
       
               //setSelectedCategory(id.target.value)    
               setSelectedItemUnit(filtered) 
               
               console.log(selectedItemUnit);

               console.log("443445454534343");

               
               console.log(selectedItemUnit[0].unit);

               console.log("443445454534343");
              
        setLoading(true);
        setselectShops(null);
        


         dispatch(getShopsByMcatID(formData.mcatId))
        .unwrap()
        .then((response)=>{
   
            if(response!=null)
            {
                if(response.message==='success')
                {
                    setselectShops(response.shopHeaders);
                    
                    setLoading(false);
                 //navigate(`/dashboard/shops/contn/${id}`)
                 //navigate(`/dashboard/shops/contn/${id}`, { replace: true }); 
                }
            }


            
        })


        console.log("54545454");
        console.log(formData.mcatId+" &&&&&"+formData.subcatId);

        console.log("54545454");
    }
   

    useEffect(()=>{


      
       
      dispatch(getAllategory())
      .unwrap()
        .then(response2 => {

            console.log("55555555");
             
if( response2!==null){
  console.log("55555555");
  console.log(response2)
  //console.log(id)
  setSelectedCategoryMain(response2);
  setSelectedSubcategory(response2)
  console.log("666666666666666666");

  
  dispatch(getAllItems(1+"_"+1))
  .unwrap()
  .then((response1)=>{

      if(response1!=null)
      {
        console.log(response1.length);


          if(response1.length >0)
          {
            console.log("545454454444");
             
            console.log(response1);
            console.log("545454454444");
            
            setAllItem(response1);
            setMainItem(response1);
            setLoading(false);

            
              console.log(mainItem);
              console.log(allItem);
              console.log("545454454444");

             


              dispatch(getItembyIdOfcView(id))
              .unwrap()
                  .then(response => {
            
            
              console.log("333333333");
               setLoading(false);
            
            
            
            //const data = JSON.parse(formData);
            console.log("44444444444444444444444444444");
            console.log(response);
            console.log("44444444444444444444444444444");
            
            
            
            if( response!==null){
                console.log("555555555555550000000000");
            
                
                console.log("555555555555550000000000");
                console.log(mainItem);
               
               // console.log(item);
               console.log("545454454444");
             
            console.log(response1);
            console.log("545454454444");
               if(response1!=null)
                {
                 const item= response1.filter(user => user.itemID===response.items.itemID);
                 console.log("55555555555555111111111111");
                 console.log(item);
                 console.log("55555555555555111111111111");
                 if(item!=null)
                     {
 
     
                      mainCat=item[0].mcatId;
                      subCat=item[0].subcatId
                       
                         if(response2!=null){
 
                         
 
                         const filtered = response2.filter(user => user.mcatId===item[0].mcatId);
                         setSelectedCategory(filtered[0])
 
                     }
                     }
                }

            
                console.log("555555555555550000000000");
                console.log(mainCat);
                console.log(subCat);
                console.log("555555555555550000000000");
            
                //
                         
            
                           //setSelectedCategory(id.target.value)    
                           //
                           

                           dispatch(getShopsByMcatID(mainCat))
                           .unwrap()
                           .then((response4)=>{
                      
                               if(response4!=null)
                               {
                                   if(response4.message==='success')
                                   {
                                       setselectShops(response4.shopHeaders);
                                       
                                       setLoading(false);
                                    //navigate(`/dashboard/shops/contn/${id}`)
                                    //navigate(`/dashboard/shops/contn/${id}`, { replace: true }); 
                                   // const tm=dayjs(response.items.validTo).format('LLLL');

                                    setvalidFrom(dayjs(response.items.validFrom))
                                    setvalidTo(dayjs(response.items.validTo))
                                    const formValues1 = {
                                        onlineId:response.items.onlineId,
                                        shopId:response.items.shopId,
                                         itemID:response.items.itemID,
                                         mcatId:mainCat,
                                        subcatId:subCat,
                                        languageType:response.items.languageType,
                                        userId:response.items.userId,
                                        brandName:response.items.brandName,
                                        mrp:response.items.mrp,
                                        price:response.items.price,
                                        unit:response.items.unit,
                                        content:response.items.discription,
                                        validFrom:response.items.validFrom,
                                        validTo:response.items.validTo
                                
                                    }
                                    console.log("55555555555555");
                                    console.log(formValues1);
                                    console.log("55555555555555");
                                    setFormData(formValues1);
                                    setEditorContent(response.items.discription);
                                    console.log("55555555555555");
                                
                                   }
                               }
                   
                   
                               
                           })
                           
            
           
                
                // state.newsID=response.news.newsMain.newsID;
                // state.heading=response.news.newsMain.newsHeading;
                // state.languageType=response.news.newsMain.languageType;
                // state.userId=response.news.newsMain.createdBy;
                // state.category=response.news.newsMain.newsCategory;
                // state.phNo=response.news.newsMain.resourcePhNo;
                // state.districtID=response.news.newsMain.districtID;
                // state.talukID=response.news.newsMain.talukID;
                
            
                // response.news.contentlist.map((item, i) => (
                //     state.content=state.content+item.newsContent,
            
                //     state.trnNO=item.transactionNo
                   
                //     ));
            
            
             
            
            
            }
            
            
            
            
            
            //console.log(response);
            
            
            //setFormData()
            
            //setFormData().setFieldValue
            
            
            //setFormData(response);
            // setEditorContent(state.content);
            
            //setState();
            console.log("3434343");
            console.log(formData);
            console.log("3434343");
            
            })


          }
      }


      
  })

 }
})



        






  
},[id,dispatch])


    return(
        <>
        <AdminTitle title="Edit Item"/>
        { shop.loading ?
                <Loader/>
            :
            <>
        <form className='mt-3 news_form' onSubmit={formik.handleSubmit}>

        <Divider className='mt-3 mb-3'/>
                   <div className='form-group'>
                   <FormControl fullWidth>
                <InputLabel>SELECT THE CATEGORY</InputLabel>
                <Select
                
                    name="mcatId"
                    label="SELECT THE CATEGORY"
                    {...formik.getFieldProps('mcatId')}
                    error={ formik.errors.mcatId && formik.touched.mcatId ? true:false}
                    onChange={(e) => handleChange(e)}
                >
                    { selectedCategoryMain ? 
                    
                    selectedCategoryMain.map(item=>(
                       // setSelectedSubcategory(item),
                        <MenuItem key={item.mcatId} value={item.mcatId}>
                            {item.discription}
                            
                            
                        </MenuItem>

                
                        
                    ))
                :null}
                </Select>
                { formik.errors.mcatId && formik.touched.mcatId ?
                    <FormHelperText error={true}>
                        { formik.errors.mcatId}
                    </FormHelperText>
                :null
                }
            </FormControl>
            </div>


            <Divider className='mt-3 mb-3'/>
                   <div className='form-group'>
                   <FormControl fullWidth>
                <InputLabel>SELECT SUB CATEGORY </InputLabel>
                <Select
                    name="subcatId"
                    label="SELECT SUB CATEGORY "
                    {...formik.getFieldProps('subcatId')}
                    error={ formik.errors.subcatId && formik.touched.subcatId ? true:false}
                    onChange={(e) => handleChangeSubCat(e)}
                >
                    { selectedCategory ? 
                  //selectedSubcategory.findIndex(x => x.mcatId === 1) .subcateList.map(item=>(
                    selectedCategory.subcateList.map(item=>(
                        <MenuItem key={item.subcatId} value={item.subcatId}>
                            {item.discription}
                        </MenuItem>
                       // console.log("UUUUUUUUU")
                       
                    ))
                :null}
                </Select>
                { formik.errors.subcatId && formik.touched.subcatId ?
                    <FormHelperText error={true}>
                        { formik.errors.subcatId}
                    </FormHelperText>
                :null
                }
            </FormControl>
            </div>

<Divider className='mt-3 mb-3'/>
                   <div className='form-group'>
                   <FormControl fullWidth>
                <InputLabel>SELECT  ITEM</InputLabel>
                <Select
                    name="itemID"
                    label="SELECT THE ITEM"
                    {...formik.getFieldProps('itemID')}
                    error={ formik.errors.itemID && formik.touched.itemID ? true:false}
                 onChange={(e) => handleItemSelection(e)}
                >
                    { mainItem ? 
                    
                    mainItem.map(item=>(
                       // setSelectedSubcategory(item),
                        <MenuItem key={item.itemID} value={item.itemID}>
                            {item.eName+" ,"+item.kName}
                            
                            
                        </MenuItem>

                
                        


                    ))
                :null}
                </Select>
                { formik.errors.itemID && formik.touched.itemID ?
                    <FormHelperText error={true}>
                        { formik.errors.itemID}
                    </FormHelperText>
                :null
                }
            </FormControl>
            </div>
            <Divider className='mt-3 mb-3'/>
                   <div className='form-group'>
                   <FormControl fullWidth>
                <InputLabel>SELECT A SHOP</InputLabel>
                <Select
                    name="shopId"
                    label="SLECT YOUR SHOP"
                    {...formik.getFieldProps('shopId')}
                    error={ formik.errors.shopId && formik.touched.shopId ? true:false}
                    //onChange={(e) => handleShopsSelection(e)}
                >
                    { selectShops ? 
                    
                    selectShops.map(item=>(
                       // setSelectedSubcategory(item),
                        <MenuItem key={item.shopId} value={item.shopId}>
                            {item.shopName+" ,"+item.name}
                            
                            
                        </MenuItem>

                
                        
                    ))
                :null}
                </Select>
                { formik.errors.shopId && formik.touched.shopId ?
                    <FormHelperText error={true}>
                        { formik.errors.shopId}
                    </FormHelperText>
                :null
                }
            </FormControl>
            </div>


            <Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <FormControl fullWidth>
                <InputLabel>Select the  language</InputLabel>
                <Select
                    name="languageType"
                    label="Select the language"
                    {...formik.getFieldProps('languageType')}
                    error={ formik.errors.languageType && formik.touched.languageType ? true:false}
                >
                   <MenuItem value= {0}><em>None</em></MenuItem>
                    <MenuItem value={1}>ENGLISH</MenuItem>
                    <MenuItem value={2}>KANNADA</MenuItem>
                </Select>
                { formik.errors.languageType && formik.touched.languageType ?
                    <FormHelperText error={true}>
                        { formik.errors.languageType}
                    </FormHelperText>
                :null
                }
            </FormControl>
</div>



            <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="brandName"
                    label="ENTER THE BRAND OR PRODUCT NAME"
                    variant="outlined"
                    {...formik.getFieldProps('brandName')}
                    {...errorHelper(formik,'brandName')}


                  
                   
                />
            </div>

            { selectedItemUnit ? 
                    <>
                    <Divider className='mt-3 mb-3'/>
                   <h6 color="Red">The item unit is in " {selectedItemUnit[0].unit} " kindly it same or specify your product unit </h6>
                   </>
                :null}

<div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name=""
                    label="ENTER UNITE OF THE PRODUCT"
                    variant="outlined"
                    {...formik.getFieldProps('unit')}
                    {...errorHelper(formik,'unit')}


                  
                   
                />
            </div>

    

    <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="mrp"
                    label="ENTER MRP OF THE PRODUCT"
                    variant="outlined"
                    {...formik.getFieldProps('mrp')}
                    {...errorHelper(formik,'mrp')}


                  
                   
                />
            </div>

            <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="price"
                    label="ENTER SELLING  PRICE OF THE PRODUCT"
                    variant="outlined"
                    {...formik.getFieldProps('price')}
                    {...errorHelper(formik,'price')}


                  
                   
                />
            </div>
      
           
          
           
            <Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <h6 color="Red"> add Item full discriotion</h6>
         
          
                <WYSIWYG
                    setEditorState={(state)=>handleEditorState(state)}
                    setEditorBlur={(blur)=> handleEditorBlur(blur)}
                    onError={formik.errors.content}
                    editorBlur={editorBlur}
                    editorContent={editorContent}
                />
                { formik.errors.content || (formik.errors.content && editorBlur) ?
                    <FormHelperText error={true}>
                        {formik.errors.content}
                    </FormHelperText>
                    :null
                }
               
            </div> 
            <Divider className='mt-3 mb-3'/>
            


<div className='form-group'>
<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['TimePicker','StaticTimePicker']}>
        <DatePicker
        style={{ width:'100%'}}
        name="validFrom"
          label="VALIDE  DATE FROM"
          value={validFrom}
          onChange={(newValue) => setvalidFrom(newValue)}
      
        />
</DemoContainer>
</LocalizationProvider>
            </div>


            <div className='form-group'>
<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['TimePicker','StaticTimePicker']}>
        <DatePicker
        style={{ width:'100%'}}
        name="validTo"
          label="VALIDE  DATE TILL "
          value={validTo}
          onChange={(newValue) => setvalidTo(newValue)}
      
        />
</DemoContainer>
</LocalizationProvider>
            </div>


           
            
           
{/* 
            <div className='form-group'>
                <WYSIWYG
                    setEditorState={(state)=>handleEditorState(state)}
                    setEditorBlur={(blur)=> handleEditorBlur(blur)}
                    onError={formik.errors.content}
                    editorBlur={editorBlur}
                />
                { formik.errors.content || (formik.errors.content && editorBlur) ?
                    <FormHelperText error={true}>
                        {formik.errors.content}
                    </FormHelperText>
                    :null
                }
            </div> */}


            <Divider className='mt-3 mb-3'/>
          
          
            { shop.loading ?
                    <Loader/>
                :
                <Button
                    variant='contained'
                    color="primary"
                    type="submit"
                >
                    UPDATE  ITEM
                </Button>
                }

        </form>
        </>
}
    </>
    )

}
export default EditOnlineItem;